import React, { useState, useRef } from 'react';
import emailjs from "@emailjs/browser";
import { Container, Row, Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import { motion, AnimatePresence } from "framer-motion";
import AnimatedSection from "../AnimatedSection";
import './Contact.css';

const Contact = () => {
  const form = useRef();
  const [done, setDone] = useState(false);
  const [notDone, setNotDone] = useState(false);
  const [formData, setFormData] = useState({
    from_name: "",
    reply_to: "",
    message: ""
  });
  const [focusedField, setFocusedField] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setDone(false);
    setNotDone(false);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!formData.from_name || !formData.reply_to || !formData.message) {
      setNotDone(true);
    } else {
      emailjs
        .sendForm(
          "service_iur9p7j",
          "template_wcmenwx",
          form.current,
          "rVv7xXNAmrPeeJ6NB"
        )
        .then(
          (result) => {
            console.log(result.text);
            setDone(true);
            setFormData({ from_name: "", reply_to: "", message: "" });
          },
          (error) => {
            console.log(error.text);
          }
        );
    }
  };

  return (
    <Container className="contact-form-container">
      <Row className="align-items-center">
        <Col md={6} className="c-left">
          <AnimatedSection direction="left" delay={0.1}>
            <div className="contact-title-group">
              <h1 className="contact-subtitle">Get in Touch</h1>
              <h1 className="contact-main-title yellow">Contact Me</h1>
              <p className="contact-desc">
                Have a project in mind, want to collaborate, or just say hello? 
                Drop a message and I'll get back to you as soon as possible.
              </p>
            </div>
          </AnimatedSection>
        </Col>
        
        <Col md={6} className="c-right">
          <AnimatedSection direction="right" delay={0.2}>
            <div className="glass-form-card">
              <form ref={form} onSubmit={sendEmail} className="contact-form">
                
                <div className="input-group-custom">
                  <input
                    type="text"
                    name="from_name"
                    id="from_name"
                    required
                    value={formData.from_name}
                    className="user-input"
                    onChange={handleChange}
                    onFocus={() => setFocusedField("from_name")}
                    onBlur={() => setFocusedField(null)}
                  />
                  <label 
                    htmlFor="from_name"
                    className={`input-label ${focusedField === "from_name" || formData.from_name ? "active" : ""}`}
                  >
                    Name
                  </label>
                </div>

                <div className="input-group-custom">
                  <input
                    type="email"
                    name="reply_to"
                    id="reply_to"
                    required
                    value={formData.reply_to}
                    className="user-input"
                    onChange={handleChange}
                    onFocus={() => setFocusedField("reply_to")}
                    onBlur={() => setFocusedField(null)}
                  />
                  <label 
                    htmlFor="reply_to"
                    className={`input-label ${focusedField === "reply_to" || formData.reply_to ? "active" : ""}`}
                  >
                    Email
                  </label>
                </div>

                <div className="input-group-custom">
                  <textarea
                    name="message"
                    id="message"
                    required
                    value={formData.message}
                    className="user-input user-textarea"
                    onChange={handleChange}
                    onFocus={() => setFocusedField("message")}
                    onBlur={() => setFocusedField(null)}
                  />
                  <label 
                    htmlFor="message"
                    className={`input-label ${focusedField === "message" || formData.message ? "active" : ""}`}
                  >
                    Message
                  </label>
                </div>

                <AnimatePresence>
                  {notDone && (
                    <motion.span 
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0 }}
                      className='not-done'
                    >
                      Please, fill in all input fields.
                    </motion.span>
                  )}
                  {done && (
                    <motion.span 
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0 }}
                      className='done'
                    >
                      Thanks for reaching out! Your message was sent successfully.
                    </motion.span>
                  )}
                </AnimatePresence>

                <motion.div 
                  whileHover={{ scale: 1.03 }} 
                  whileTap={{ scale: 0.97 }}
                  style={{ width: "100%" }}
                >
                  <Button type="submit" className="button submit-btn" disabled={done}>
                    {done ? "Sent!" : "Send Message"}
                  </Button>
                </motion.div>

              </form>
            </div>
          </AnimatedSection>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;